import { useEffect } from "react";

/**
 * Hook para alterar dinamicamente o título e favicon da aba do navegador.
 * @param {string} title - Título da página (será prefixado com "SIDEB+ | ")
 * @param {string} [favicon] - Caminho do favicon (relativo a /public). Se não informado, usa o padrão.
 */
export default function usePageMeta(title, favicon) {
  useEffect(() => {
    document.title = title ? `SIDEB+ | ${title}` : "SIDEB+";
  }, [title]);

  useEffect(() => {
    if (!favicon) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = favicon;
  }, [favicon]);
}
